var menuDivs = document.querySelectorAll(".naccs .menu .accordion_tab-title");

menuDivs.forEach(function (div) {
  div.addEventListener("click", function (event) {
    var clickedElement = event.target;
    var numberIndex = Array.from(menuDivs).indexOf(clickedElement);

    if (!clickedElement.classList.contains("active")) {
      var listItems = document.querySelectorAll(".naccs .tab_list .tab_list_item");

      menuDivs.forEach(function (div) {
        div.classList.remove("active");
      });

      listItems.forEach(function (li) {
        li.classList.remove("active");
      });

      clickedElement.classList.add("active");
      listItems[numberIndex].classList.add("active");

      // var listItemHeight = listItems[numberIndex].offsetHeight;
      // document.querySelector(".naccs ul").style.minHeight =
      //   listItemHeight + "px";
    }
  });
});
